import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const MyCare: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <path
      fill="#002677"
      d="M34.477 14.023a2.095 2.095 0 0 0-2.095 2.095v6.287h-1.048V9.831a2.095 2.095 0 0 0-4.19 0v12.573h-1.048V6.689a2.096 2.096 0 0 0-4.192 0v15.715h-1.047V9.832a2.095 2.095 0 0 0-4.19 0v18.859l-1.049.365v-7.699a2.095 2.095 0 1 0-4.19 0v10.477c0 6.943 5.628 12.572 12.572 12.572 6.943 0 12.572-5.629 12.572-12.572V16.118a2.095 2.095 0 0 0-2.095-2.095Z"
    />
    <path
      fill="#FF612B"
      d="M31.109 25.917a4.344 4.344 0 0 0-6.144 0l-.965.965-.966-.965a4.344 4.344 0 1 0-6.143 6.144l7.107 7.107.002-.002.002.002 7.107-7.107a4.344 4.344 0 0 0 0-6.144Z"
    />
  </Box>
)
export default MyCare
